// General Tracking Events
export const Page_Viewed = "Page_Viewed";
export const Section_Viewed = "Section_Viewed";
export const Link_Clicked = "Link_Clicked";

// General Component Custom Events
export const Accordion_Toggle_Click = "Accordion_Toggle_Click";
export const Load_More = "Load_More";
export const Carousel_Toggle_Click = "Carousel_Toggle_Click";
export const Tab_Click = "Tab_Click";

// PageView Events
export const Page_View = "Page_View";

// Ecommerce Events
export const View_Item_List = "View_Item_List";
export const Select_Item = "Select_Item";
export const View_Item = "View_Item";
export const Add_To_Shopify_Cart = "Add_To_Shopify_Cart";
export const Remove_From_Cart = "Remove_From_Cart";
export const View_Cart = "View_Cart";
export const Checkout = "Checkout";

// Interaction Events
export const Social_Share = "Social_Share";
export const App_Download = "App_Download";
export const File_Download = "File_Download";
export const Generate_Lead = "Generate_Lead";
export const Email_Signup = "Email_Signup";
export const Audio_Start = "Audio_Start";
export const Faq_Action = "Faq_Action";
export const Faq_Load_More = "Faq_Load_More";
export const Reviews_Cta = "Reviews_Cta";
export const Navigation = "Navigation";
export const Cta_Click = "Cta_Click";
export const Item_Details = "Item_Details";

// General GA Action Values
export const Clicked = "Clicked";
export const Click = "Click";

// Event Property Names
export const Product = "Product";
export const Button_Location = "Button_Location";
export const Button_Text = "Button_Text";
export const Link_Text = "Link_Text";
export const Section_Name = "Section_Name";
export const Page_Name = "Page_Name";
export const Page_Url = "Page_Url";
export const Variant_Name = "Variant_Name";
export const Product_Variant = "Product_Variant";
export const Price = "Price";
export const Action = "Action";
export const Cart_Items = "Cart_Items";
export const Number_Of_Line_Items = "Number_Of_Line_Items";
export const Total_Quantity = "Total_Quantity";
export const Subtotal = "Subtotal";
export const Decrease_Quantity = "Decrease_Quantity";
export const Increase_Quantity = "Increase_Quantity";
export const Current_Quantity = "Current_Quantity";
export const New_Quantity = "New_Quantity";
export const Name = "Name";

// Event Property Values
// (Button Text)
export const Join_Now = "Join_Now";
export const Buy_Now = "Buy_Now";
export const Buy_On_Amazon = "Buy_On_Amazon";
export const Learn_More = "Learn_More";

// (Products)
export const Rest = "Rest";
export const Rest_Plus = "Rest_Plus";
export const Restore = "Restore";
export const Grow = "Grow";
export const Coverlets = "Coverlets";

// (Actions)
export const Add_To_Cart_Cta_Clicked = "Add_To_Cart_Cta_Clicked";
export const Remove_Item_Icon_Clicked = "Remove_Item_Icon_Clicked";
export const Decrease_Quantity_Icon_Clicked = "Decrease_Quantity_Icon_Clicked";
export const Increase_Quantity_Icon_Clicked = "Increase_Quantity_Icon_Clicked";
export const Checkout_Button_Clicked = "Checkout_Button_Clicked";
export const Cart_Backdrop_Clicked = "Cart_Backdrop_Clicked";
export const Close_Cart_Icon_Clicked = "Close_Cart_Icon_Clicked";
export const Header_Cart_Icon_Clicked = "Header_Cart_Icon_Clicked";
export const Shop_Restore_Button_Clicked = "Shop_Restore_Button_Clicked";
export const Shop_Rest_Family_Button_Clicked =
  "Shop_Rest_Family_Button_Clicked";
export const Shop_Sleep_Button_Clicked = "Shop_Sleep_Button_Clicked";
export const Shop_Nav_Toggle_Clicked = "Shop_Nav_Toggle_Clicked";
export const Shop_Subnav_Link_Clicked = "Shop_Subnav_Link_Clicked";
export const Shop_Mobile_Menu_Icon_Clicked = "Shop_Mobile_Menu_Icon_Clicked";
export const Open = "Open";
export const Close = "Close";

// (Page Names)
export const Rest_Plus_Product_Page = "Rest_Plus_Product_Page";
export const Rest_Product_Page = "Rest_Product_Page";
export const Homepage = "Homepage";

// (Section Names)
export const Product_Module = "Product_Module";
export const Product_Details = "Product_Details";
export const Product_App_Section = "Product_App_Section";
export const Comparison_Chart = "Comparison_Chart";
export const Hero = "Hero";
export const Buy_Box = "Buy_Box";
export const Cart = "Cart";
export const Modal = "Modal";
export const Empty_Cart = "Empty_Cart";
export const Main_Header = "Main_Header";
export const Recommended_Products = "Recommended_Products";
export const All_Things_Sleep = "All_Things_Sleep";
export const Sleep_Must_Haves = "Sleep_Must_Haves";
export const Collection_Featured_Product = "Collection_Featured_Product";
export const Sleep_Slideshow = "Sleep_Slideshow";
export const Hero_Carousel = "Hero_Carousel";
export const Hatch_Sleep_Membershp_Carousel = "Hatch_Sleep_Membershp_Carousel";
export const Sleep_Member = "Sleep_Member";
export const Sleep_Experience = "Sleep_Experience";
export const Sticky_Add_To_Cart_Bar = "Sticky_Add_To_Cart_Bar";
export const Collection_Product_Card = "Collection_Product_Card";
export const FAQ = "FAQ";
export const App_Screen_Carousel = "App_Screen_Carousel";
export const Sleep_Membership = "Sleep_Membership";
export const Kids_Group_Covered = "Kids_Group_Covered";
export const App_Controls = "App_Controls";
export const Signup_Form = "Signup_Form";
export const How_It_Works = "How_It_Works";

// Main Nav/Subnav Events
export const Main_Nav_Link_Click = "Main_Nav_Link_Click";
export const Subnav_Link_Click = "Subnav_Link_Click";

// (Subnav Main Categories)
export const Shop_Sleep = "Shop_Sleep";
export const For_Adults = "For_Adults";

// This is also an event value for Dream Shop Subnav Links
export const For_Babies_And_Kids = "For_Babies_And_Kids";
export const For_You = "For_You";
export const For_The_Littles = "For_The_Littles";

// (Dream Shop Subnav Links)
export const For_Falling_Asleep = "For_Falling_Asleep";
export const For_Staying_Asleep = "For_Staying_Asleep";
export const For_Waking_Up_Refreshed = "For_Waking_Up_Refreshed";
export const All_Products = "All_Products";

// Product Signup Flow - Events
export const Buy_Now_Button_Tapped = "Buy_Now_Button_Tapped";
export const Learn_More_Button_Tapped = "Learn_More_Button_Tapped";
export const Start_Consultation_Tapped = "Start_Consultation_Tapped";
export const Add_To_Cart = "Add_To_Cart";

// Cart - Events
export const Close_Cart = "Close_Cart";
export const Open_Cart = "Open_Cart";
export const Shop_Button_Clicked = "Shop_Button_Clicked";

// Misc
export const Mailchimp_Signup_Completed = "Mailchimp_Signup_Completed";
export const Lead_Gen_Signup_Completed = "Lead_Gen_Signup_Completed";

// Carousel Property Values
export const Dot_Toggle_Click = "Dot_Toggle_Click";
export const Next_Arrow_Toggle = "Next_Arrow_Toggle";
export const Prev_Arrow_Toggle = "Prev_Arrow_Toggle";
export const Sliding_Indicator_Copy_Toggle = "Sliding_Indicator_Copy_Toggle";

// Video - Events
export const Video_Complete = "Video_Complete";
export const Video_Progress = "Video_Progress";
export const Video_Start = "Video_Start";

export const ACTIONS = {
  Clicked,
  Click,
};

export const STANDARD_EVENTS = {
  Page_Viewed,
  Link_Clicked,
  Buy_Now_Button_Tapped,
  Learn_More_Button_Tapped,
  Start_Consultation_Tapped,
  Section_Viewed,
  Add_To_Cart,
  Close_Cart,
  Open_Cart,
  Shop_Button_Clicked,
  Decrease_Quantity,
  Increase_Quantity,
  Mailchimp_Signup_Completed,
  Shop_Nav_Toggle_Clicked,
  Shop_Subnav_Link_Clicked,
  Shop_Mobile_Menu_Icon_Clicked,
  Lead_Gen_Signup_Completed,
  Main_Nav_Link_Click,
  Subnav_Link_Click,
  Accordion_Toggle_Click,
  Load_More,
  Carousel_Toggle_Click,
  Tab_Click,
  Page_View,
  View_Item_List,
  Select_Item,
  View_Item,
  Add_To_Shopify_Cart,
  Remove_From_Cart,
  View_Cart,
  Checkout,
  Social_Share,
  App_Download,
  File_Download,
  Generate_Lead,
  Email_Signup,
  Audio_Start,
  Faq_Action,
  Faq_Load_More,
  Reviews_Cta,
  Navigation,
  Cta_Click,
  Item_Details,
  Video_Complete,
  Video_Progress,
  Video_Start,
};

export const EVENT_PROPERTIES_NAMES = {
  Product,
  Button_Location,
  Button_Text,
  Link_Text,
  Section_Name,
  Page_Name,
  Page_Url,
  Variant_Name,
  Product_Variant,
  Price,
  Action,
  Cart_Items,
  Number_Of_Line_Items,
  Total_Quantity,
  Subtotal,
  Current_Quantity,
  New_Quantity,
  Name,
};

export const EVENT_PROPERTIES_VALUES = {
  Product_Module,
  Product_App_Section,
  Main_Header,
  Modal,
  Rest,
  Rest_Plus,
  Restore,
  Grow,
  Join_Now,
  Buy_Now,
  Buy_On_Amazon,
  Learn_More,
  Buy_Box,
  Product_Details,
  All_Things_Sleep,
  Hero,
  For_Adults,
  Cart,
  Empty_Cart,
  Comparison_Chart,
  Recommended_Products,
  Hero_Carousel,
  Hatch_Sleep_Membershp_Carousel,
  Add_To_Cart_Cta_Clicked,
  Remove_Item_Icon_Clicked,
  Decrease_Quantity_Icon_Clicked,
  Increase_Quantity_Icon_Clicked,
  Checkout_Button_Clicked,
  Cart_Backdrop_Clicked,
  Close_Cart_Icon_Clicked,
  Header_Cart_Icon_Clicked,
  Shop_Restore_Button_Clicked,
  Shop_Rest_Family_Button_Clicked,
  Rest_Plus_Product_Page,
  Rest_Product_Page,
  Homepage,
  Sleep_Must_Haves,
  Collection_Featured_Product,
  Sleep_Slideshow,
  Sleep_Member,
  Sleep_Experience,
  Sticky_Add_To_Cart_Bar,
  Collection_Product_Card,
  FAQ,
  Dot_Toggle_Click,
  Next_Arrow_Toggle,
  Prev_Arrow_Toggle,
  Sliding_Indicator_Copy_Toggle,
  App_Screen_Carousel,
  Sleep_Membership,
  Kids_Group_Covered,
  App_Controls,
  Signup_Form,
  How_It_Works,
  // Subnav
  For_Falling_Asleep,
  For_Staying_Asleep,
  For_Waking_Up_Refreshed,
  For_Babies_And_Kids,
  For_You,
  For_The_Littles,
  All_Products,
  Shop_Sleep,
  Open,
  Close,
};

const Amplitude = {
  STANDARD_EVENTS,
  ACTIONS,
};

export default Amplitude;
